import React, { useEffect, useState } from "react";
import InputText from '../ReusableComponents/InputText';
import TextArea from '../ReusableComponents/TextArea';
import AutoDropDown from '../ReusableComponents/AutoCompleteDropDown';

const ItemsCategorypopup = ({ data, itemTypeOptions = [] }) => {
  const [bindItemType, setBindItemType] = useState([]);

  useEffect(() => {
  
    setBindItemType(itemTypeOptions);
  }, [itemTypeOptions]);

  const selectedItemType = bindItemType.find(
    (item) => item.value === data?.MstItemTypeId
  );

  if (!data) return null;

  return (
    <div className="mx-auto md:w-[500px] w-full">
      <div className="relative w-full h-full max-w-xl md:h-auto">
        <div className="relative bg-white rounded-lg shadow">
          <div className="px-6 py-6 lg:px-8">
            <form className="space-y-6" action="#">
              <AutoDropDown
                title="Item Type"
                name="itemType"
                classStar="text-red-500"
                options={bindItemType}
                selectedOption={selectedItemType}
                placeholder="Select"
                Class="p-0"
                disabled={true}
              />

              <InputText
                inputType="text"
                title="Item Category"
                name="itemscategory"
                classStar="text-red-500"
                content={data?.ItemCategory}
                disabled={true}
                isRequired={true}
              />

              <TextArea
                title="Description"
                rows={7}
                name="description"
                content={data?.Description}
                resize={false}
                placeholder="Enter description"
                disabled={true}
                // tabIndex="0"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemsCategorypopup;
